import { MotifButton, MotifFormField, MotifIcon, MotifInlineMessage, MotifInput } from '@ey-xd/motif-react'
import React, { useEffect, useState } from 'react'
import iconSvg from "../../assets/icons/icon.svg.json";
import { useDispatch, useSelector } from 'react-redux';

const ChatMessageInput = () => {
    let selectConversations = useSelector((state: any) => state.conversations);
    const [message, setMessage] = useState('');
    const [error, setError] = useState<any>();
    const [inputDisabled, setInputDisabled] = useState(false);
    const { access } = useSelector((state: any) => state.user);

    useEffect(() => {
        if (selectConversations.conversations && selectConversations.conversations.length > 0 && selectConversations?.conversations[selectConversations?.conversations?.length - 1]?.message?.inputType === 'text') {
            setInputDisabled(false);
        } else {
            setInputDisabled(true);
        }
        if (selectConversations.conversations === null) {
            setInputDisabled(true);
        }
        if(selectConversations.conversationCategory === "Generic") {
            setInputDisabled(false);
        }
        if(access.write === false) {
            setInputDisabled(true);
        }
    }, [selectConversations, access])

    const dispatch = useDispatch();
    const onChange = (e: any) => {
        setMessage(e.target.value);
    }
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            onSubmit();
        }
    };
    const onSubmit = () => {
        if (message === '') {
            setError('Please enter a message');
            return;
        }
        setError(undefined);
        dispatch({ type: "CONVERSATION_MESSAGE_SEND", payload: { text: message } });
        setMessage('');
    }

    return (
        <div className='px-5 pb-3 flex gap-5'>
            <div style={{ width: "calc(100% - 2rem)" }}>
                <MotifFormField
                    aria-label="Input"
                    role="group"
                >
                    <MotifInput
                        disabled={inputDisabled}
                        aria-label="Input"
                        ariaLabel="Input"
                        id="input"
                        label="Input"
                        value={message}
                        onKeyPress={handleKeyPress}
                        onChange={onChange}
                        placeholder="Type in here..."
                        className="!rounded-md"
                    />
                </MotifFormField>
                {error && (
                    <MotifInlineMessage variant="error">
                        {error}
                    </MotifInlineMessage>
                )}
            </div>
            <MotifButton
                disabled={inputDisabled}
                onClick={onSubmit}
                variant="primary"
                size="small"
                className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
            >
                <MotifIcon src={iconSvg["send-message"]} className="w-5" title='Harrow-right' />
            </MotifButton>
        </div>
    )
}

export default ChatMessageInput